import React from 'react';
import { Flex, Text } from '@locus-taxy/neo-ui';

class DefaultTableCell extends React.PureComponent {
    render() {
        const { value, ...others } = this.props;
        return (
            <Flex
                alignItems="center"
                height="32px"
                {...others}
                sx={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    width: '100%'
                }}
            >
                <Text truncated>{value}</Text>
            </Flex>
        );
    }
}

export default DefaultTableCell;
